module.exports = __webpack_public_path__ + "static/media/ed-roman-2.20f9016b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/ed-roman-2.jpg
// module id = 219
// module chunks = 0